module.exports = __webpack_public_path__ + "packs/media/images/logo-icon-d0057f55d0172bd9f9997c18583288c8.png";